import React, { useState } from 'react';
import { GoogleMap, LoadScript, Marker, Circle } from '@react-google-maps/api';

import Container from '@material-ui/core/Container';

import Loading from 'components/Loading/Loading';

import {
    ContainerMapaAnuncio,
    MapaPreview,
    MostrarMapaBtn,
    NotFoundAlert,
    Titulo,
} from './mapaAnuncio-styled';

const MapaAnuncio = ({ anuncio }) => {
    const [mostrarMapa, setMostrarMapa] = useState(false);

    const showMap = () => {
        setMostrarMapa(true);
    };

    const center = {
        lat: anuncio.latitude,
        lng: anuncio.longitude,
    };

    const containerStyle = {
        width: '100%',
        height: '100%',
        overflow: 'visible',
    };

    return (
        <ContainerMapaAnuncio>
            <Container>
                <Titulo>Localização</Titulo>
            </Container>

            {mostrarMapa ? (
                anuncio.latitude && anuncio.longitude ? (
                    <LoadScript
                        googleMapsApiKey={process.env.MAPA_API_KEY}
                        loadingElement={<Loading />}
                    >
                        <GoogleMap
                            zoom={17}
                            mapContainerStyle={containerStyle}
                            center={center}
                        >
                            {anuncio.tipoLocalizacao === 'EXATO' && (
                                <Marker position={center} />
                            )}

                            {anuncio.tipoLocalizacao === 'APROXIMADO' && (
                                <Circle center={center} radius={150} />
                            )}
                        </GoogleMap>
                    </LoadScript>
                ) : (
                    <MapaPreview>
                        <NotFoundAlert>
                            Desculpe, o endereço não <br /> foi localizado no
                            mapa!
                        </NotFoundAlert>
                    </MapaPreview>
                )
            ) : (
                <MapaPreview>
                    <MostrarMapaBtn onClick={showMap}>
                        Ver no mapa
                    </MostrarMapaBtn>
                </MapaPreview>
            )}
        </ContainerMapaAnuncio>
    );
};

export default MapaAnuncio;
